module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Heavy.ttf?b7c3e58a4ece5fcdd5700b7b7af189a9";